export default __webpack_public_path__ + "680d9f2b193ea08053d1cb70bf4ce365.png";